<template>
  <a-spin :spinning="spinning">
    <ele-table
      ref="rt"
      :columns="columns"
      :table-data="data"
      :total-items="totalItems"
      :actions-type="actionsType"
      :is-full="true"
      :current-page="pageNumber"
      :hide-row-selection="true"
      @emitRefreshData="clearFilterAndRefresh"
      @emitSortData="updateSortData"
      @emitSelectChange="updateSelectChange"
      @emitOnPageChange="updatePageChange"
      @emitShowSizeChange="updateShowSizeChange"
    >
      <!-- 查询 -->
      <a-row :gutter="8">
        <a-col class="gutter-row" :span="4">
          <a-date-picker
            v-model="SearchDto.year"
            mode="year"
            format="YYYY"
            placeholder="所属年"
            style="width: 100%"
            :open="yearPickerOpen"
            @openChange="handleYearPickerOpenChange"
            @panelChange="handleYearPanelChange"
          />
        </a-col>
        <a-col class="gutter-row" :span="4">
          <a-month-picker
            v-model="SearchDto.yearMonth"
            valueFormat="YYYY-MM"
            placeholder="所属月份"
            style="width: 100%"
          />
        </a-col>
        <a-col class="gutter-row" :span="3">
          <a-input
            v-model.trim="SearchDto.realName"
            placeholder="收款人姓名"
            allow-clear
          />
        </a-col>
        <a-col class="gutter-row" :span="4">
          <a-input
            v-model.trim="SearchDto.idCard"
            placeholder="身份证号码"
            allow-clear
          />
        </a-col>
        <a-col class="gutter-row" :span="3">
          <a-input
            v-model.trim="SearchDto.phone"
            placeholder="手机号码"
            allow-clear
          />
        </a-col>
        <a-col class="gutter-row" :span="3">
          <a-button
            type="primary"
            @click="getData()"
            v-if="isGranted('Pages.RLTax.Query')"
          >
            {{ l("Search") }}
          </a-button>
          <a-button @click="refreshGoFirstPage"> {{ l("Reset") }}</a-button>
        </a-col>
      </a-row>
    </ele-table>
  </a-spin>
</template>
<script>
import { AppComponentBase } from "@/shared/component-base";
import { ModalComponentBase } from "@/shared/component-base";
import { ModalHelper } from "@/shared/helpers";
import { CommonServiceProxy } from "@/shared/common-service";
import { fileDownloadService } from "@/shared/utils";
import moment from "moment";
import EleTable from "@/components/ele-table";
import { AppConsts } from "@/abpPro/AppConsts";

export default {
  mixins: [AppComponentBase, ModalComponentBase],
  name: "recurringLabor-tax",
  components: { EleTable },
  data() {
    return {
      spinning: false,
      selectedRowKeys: [],
      SearchDto: {
        year: moment().format('YYYY'), // 设置默认值为当前年
        yearMonth: undefined,
        realName: "",
        idCard: "",
        phone: "",
        customerId: undefined,
        companyId: undefined,
      },
      // 总记录数
      totalItems: 0,
      // 当前页码
      pageNumber: 1,
      // 总页数
      totalPages: 1,
      // 每页显示数
      pageSizeOptions: ["10", "20", "30", "40"],
      request: {
        maxResultCount: 50,
        skipCount: 0,
      },
      // 表头
      columns: [],
      actionsType: null,
      // 数据
      data: [],
       yearPickerOpen: false
    };
  },
  created() {
    this.getData();
    this.initColums();
  },
  methods: {
    initColums() {
      let _this = this;
      this.columns = [
        {
          title: "签约公司",
          dataIndex: "payCompanyName",
          key: "payCompanyName",
          sorter: false,
          align: "center",
          width: 200,
        },
        {
          title: "所属年月",
          dataIndex: "yearMonth",
          key: "yearMonth",
          sorter: true,
          align: "center",
          width: 120,
        },
        {
          title: "姓名",
          dataIndex: "userName",
          key: "userName",
          sorter: false,
          align: "center",
          width: 120,
        },
        {
          title: "身份证号",
          dataIndex: "idCard",
          key: "idCard",
          sorter: false,
          align: "center",
          width: 180,
        },
        {
          title: "手机号",
          dataIndex: "phone",
          key: "phone",
          sorter: false,
          align: "center",
          width: 120,
        },
        {
          title: "发放金额(月)",
          dataIndex: "monthAmount",
          key: "monthAmount",
          sorter: true,
          align: "center",
          width: 150,
        },
        {
          title: "税(月)",
          dataIndex: "tax",
          key: "tax",
          sorter: true,
          align: "center",
          width: 100,
        },
        {
          title: "累计税(年)",
          dataIndex: "cumulativeTax",
          key: "cumulativeTax",
          sorter: true,
          align: "center",
          width: 120,
        },
        {
          title: "增值税",
          dataIndex: "vatAmount",
          key: "vatAmount",
          sorter: true,
          align: "center",
          width: 100,
        },
        {
          title: "累计增值税",
          dataIndex: "cumulativeVat",
          key: "cumulativeVat",
          sorter: true,
          align: "center",
          width: 120,
        },
      ];
    },
    getData() {
      // 添加year为空的校验
      if (!this.SearchDto.year || this.SearchDto.year.toString().trim() === '') {
        this.$message.warning('请选择所属年份');
        return;
      }
      
      let data = { ...this.request, ...this.SearchDto };

      let newData = {};
      // 循环对象，判断对象中某些属性是否存在，且排除属性值为空格的属性
      for (let key in data) {
        if (
          data[key] !== undefined &&
          data[key] !== null &&
          data[key].toString().replace(/(^\s*)|(\s*$)/g, "") !== ""
        ) {
          newData[key] = data[key];
        }
      }

      this.$nextTick(() => {
        this.$refs.rt.clearData();
      });
      let _this = this;
      this.SendToService({
        url: "/api/services/app/RecurringLabor/GetRecurringLaborTaxPaged",
        method: "get",
        params: newData,
        success(res) {
          _this.data.splice(0, _this.data.length);
          _this.totalItems = res.totalCount;
          res.items.forEach((item) => _this.data.push(item));
          _this.data = res.items.map((item) => {
            return {
              ...item,
            };
          });
        },
      });
    },
    refreshGoFirstPage() {
      this.SearchDto = {
        year: moment().format('YYYY'), // 重置时也设置为当前年
        yearMonth: undefined,
        realName: "",
        idCard: "",
        phone: "",
        customerId: undefined,
        companyId: undefined,
      };
      this.pageNumber = 1;
      this.request.skipCount = 0;
      this.getData();
    },
    SendToService(opts) {
      this.spinning = true;
      let options = {
        url: this.$apiUrl + opts.url,
        method: opts.method,
        data: opts.data,
        params: opts.params,
        headers: { "Content-Type": "application/json-patch+json" },
      };
      this.$api
        .request(options)
        .then((res) => {
          this.spinning = false;
          if (opts.complete && typeof opts.complete == "function") {
            opts.complete(res);
          }
          if (res.status == 200) {
            if (opts.success && typeof opts.success == "function") {
              opts.success(res.data);
            }
          } else {
            abp.message.error(res.statusText);
          }
        })
        .catch((e) => {
          this.spinning = false;
          if (opts.complete && typeof opts.complete == "function") {
            opts.complete(e);
          }
          console.error(e);
        });
    },
    /*
        分页相关
        */
    // 情况查询条件并重新查询
    clearFilterAndRefresh() {
      this.request = {
        sorting: "YearMonth desc",
        maxResultCount: 50,
        skipCount: 0,
      };
      this.refreshGoFirstPage();
    },
    // 排序更新data
    updateSortData(newV) {
      let { columnKey, order } = newV;
      this.request.sorting = order ? `${columnKey} ${order}` : "";
      this.getData();
    },
    // table选择事件
    updateSelectChange(newV) {
      let { selectedRowKeys, selectedRows } = newV;
      this.onSelectChange(selectedRowKeys, selectedRows);
    },
    onSelectChange(keys, rows) {
      if (!!this.selectedRows) {
        this.selectedRows.splice(0, this.selectedRows.length);
        for (let i = 0; i < rows.length; i++) {
          this.selectedRows.push(rows[i]);
        }
      }
    },
    // 分页
    updatePageChange(newV) {
      let { page, pageSize } = newV;
      this.onChange(page, pageSize);
    },
    onChange(page, pageSize) {
      this.pageNumber = page;
      this.request.skipCount = (page - 1) * this.request.maxResultCount;
      this.getData();
    },
    updateShowSizeChange(newV) {
      let { current, size } = newV;
      this.showSizeChange(current, size);
    },
    showSizeChange(current, size) {
      this.pageNumber = 1;
      this.request.maxResultCount = size;
      this.getData();
    },
    handleYearPickerOpenChange(open) {
      this.yearPickerOpen = open;
    },
    handleYearPanelChange(value) {
      this.SearchDto.year = moment(value).format('YYYY');
      // 选择年份后手动关闭弹窗
      this.yearPickerOpen = false;
    },
  },
};
</script>

<style lang="less" scoped>
.btn--container {
  margin-top: 20px;
}

.btn--footer {
  margin-bottom: 20px;
}
.gutter-row {
  padding: 0 0 10px 5px;
}
</style>